module.exports = __webpack_public_path__ + "img/down08.c0afc488.png";